module.exports = __webpack_public_path__ + "img/attachmentSetting-2@2x.c5e21dd.webp";